export default "__VITE_ASSET__BnsnGHSK__"